
module.exports = {
    // 头部菜单
    common: {
        login: '登录',
        register:'注册',
        reset:'重置',
        app:'点击下载糖分检测APP',
        admin:'正图糖分检测系统',
        title:'成都正图科技',
        smxz:'扫码下载',
        logout:'退出',
        search:'搜索',
        add:'新增',
        password:'忘记密码'
    },
}
